import { render, staticRenderFns } from "./DamageForm.vue?vue&type=template&id=08d2fa9e&scoped=true&"
import script from "./DamageForm.vue?vue&type=script&lang=js&"
export * from "./DamageForm.vue?vue&type=script&lang=js&"
import style0 from "./DamageForm.vue?vue&type=style&index=0&id=08d2fa9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2fa9e",
  null
  
)

export default component.exports